import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneCaricaDocumentoDDTAttivoStep2Component } from './conservazione-carica-documento-ddt-attivo-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-ddt-attivo-step2', {
            url: '/conservazione-carica-ddt-attivo',
            ncyBreadcrumb: {
                label: 'Carica DDT Attivo',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-ddt-attivo-step2 flex="100"></conservazione-carica-documento-ddt-attivo-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoDDTAttivoStep2Module: string = ng
    .module('conservazione-carica-documento-ddt-attivo-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoDdtAttivoStep2', ConservazioneCaricaDocumentoDDTAttivoStep2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-ddt-attivo-step2/conservazione-carica-documento-ddt-attivo-step2.module.ts